module.exports = __webpack_public_path__ + "assets/img/fusionGateway-module4-3.bbd0ee59.jpg";